<div class="flex w-full">
    <div class="px-7"></div>
    <button [attr.data-active]="active()">
        <ng-content />
    </button>
</div>
